import React from "react";
import { Row } from "reactstrap";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";

const Features = () => (
  <section id="how">
    <div className="container">

      <Row className="justify-content-center">

        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6" id="features">
          <h2 className="txt-title txt-landing">
            <Trans>Hesaab Features</Trans>
          </h2>
          <p className="txt-content">
            <Trans>
              Explore the features that help you automate your business.
            </Trans>
          </p>
          <div className="features-list">

            <img
              src="/images/approved_icon.svg"
              alt="Arabic Invoicing Solution"
            />
            <p>
              <Trans>
                Approved by the Zakat, Tax and Customs Authority (Zatca).
              </Trans>
            </p>
          </div>

          <div className="features-list">
            <img
              src="/images/print_icon.svg"
              alt="Arabic Invoicing Solution"
            />
            <p>
              <Trans>
                Includes detailed transactions, reports and accounting features available on Xero.
              </Trans>
            </p>
          </div>
          <div className="features-list">
            <img
              src="/images/qr_code_icon.svg"
              alt="Arabic Invoicing Solution"
            />
            <p><Trans>Generate ZATCA-compliant electronic invoices with QR codes for easy access and verification.</Trans> </p><hr />
          </div>
          <div className="features-list">
            <img
              src="/images/electronicinvoice_icon.svg"
              alt="Arabic Invoicing Solution"
            />
            <p>
              <Trans>Print transactions and reports in several languages</Trans> <span className="text-success"><small><Trans>​(Arabic, English, French, Spanish, Indonesian, Chinese, Korean, German, Japanese, Italian, Turkish, Russian)</Trans></small>.</span>
            </p>
          </div>
          <div className="features-list">
            <img
              src="/images/platform_icon.svg"
              alt="Arabic Invoicing Solution"
            />
            <p><Trans>Easily integrate with local e-commerce platforms and applications to manage your accounting activity.</Trans></p><hr />
          </div>
          <div className="features-list">
            <img
              src="/images/system_icon.svg"
              alt="Arabic Invoicing Solution"
            />
            <p><Trans>Human Resources system for employee management, including loans, holidays, end-of-service, and attendance report...</Trans></p><hr />
          </div>

          <div className="features-list">
            <img
              src="/images/payrollsolutions-icon.svg"
              alt="Arabic Invoicing Solution"
            />
            <p><Trans>Task management help you to organize your work through add and follow up on different tasks and projects.</Trans></p>
          </div>


        </div>
        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right features">
          <img
            src="/images/hesaab_platform.svg"
            alt="Arabic Invoicing Solution"
          />

        </div>



      </Row>
    </div>
  </section>
);

export default Features;
